import React, { useEffect, useState } from "react";

interface ProgressBarProps {
  loading: boolean;
  className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ loading, className }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (loading) {
      setProgress(0);
      interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval!);
            return 100;
          }
          return prev + 1;
        });
      }, 20);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [loading]);

  if (!loading) return null;

  return (
    <div
      role="progressbar"
      className={`h-1 bg-gray-300 ${className}`}
      style={{
        width: `${progress}%`,
        transition: "width 0.2s linear",
      }}
    />
  );
};

export default ProgressBar;
